/******************************************************************************************
 *	Generic HTTP Interceptor
 ******************************************************************************************/
(function() {
  

  angular.module('rcServices.httpInterceptor', []).factory(
    'httpInterceptor',
    /* @ngInject */
    function($q, $injector, $window, DemoMode) {
      return {
        responseError: function(rejection) {
          //Logout if 401 - Unauthorized is received.
          //Rather vulgar, but will do for now.
          //In the future, this should postpone the original $http call, log the user in,
          //then if all is good, replay the call that triggered all this.
          if (rejection.status === 401) {
            //FR: TODO ~ What should happen if a call in demo mode slips to JIL?
            if (!DemoMode.isEnabled() && !$window.fakes) {
              //Using $injector to avoid circular dependency
              var Redirector = $injector.get('Redirector');
              Redirector.go('logout');
            }
          }

          return $q.reject(rejection);
        }
      };
    }
  );
})();
